<template>
  <div>
    <page-header
      title="Collections"
      breadcrumb="Billings & Collections > Collections"
    />
    <section class="bg-white my-4 p-3">
      <div class="flex border-b-2 border-gray-400 pt-2">
        <div
          class="tab-item"
          :class="{ active: currentTab == 'private' }"
          @click="currentTab = 'private'"
        >
          <p>Private</p>
        </div>
        <div
          class="tab-item"
          :class="{ active: currentTab == 'corporate' }"
          @click="currentTab = 'corporate'"
        >
          <p>Corporate</p>
        </div>
      </div>

      <div class="flex py-4 justify-between">
        <div class="unit-point">
          <p class="w-full">Transaction Count: {{ totalCollection }}</p>
          <span class="w-12"
            ><img src="@/assets/images/billing/total_value.svg"
          /></span>
        </div>
        <div class="unit-point">
          <p class="w-full">
            Total Value: ₦
            {{
              allCollectionProperty.totalAmount
                ? allCollectionProperty.totalAmount.toLocaleString()
                : "N/A"
            }}
          </p>
          <span class="w-12"
            ><img src="@/assets/images/billing/total_value.svg"
          /></span>
        </div>
      </div>

      <TableFilter @setQueryparams="sortItemProps" />
      <div v-loading="loading">
        <TableCollections :tableContent="allCollection" />
      </div>
      <PaginationControl
        :total="totalCollection"
        :pageNumber="sortOptions.pageNumber"
        @pageNumber="setPageDisplayCollection"
        @pageSize="setNumDisplayCollection"
      />
    </section>
  </div>
</template>

<script>
import moment from "moment";
import TableFilter from "../modules/TableFilter.vue";
import TableCollections from "../modules/TableCollections.vue";
import PageHeader from "@/components/UI/NewPageHeader";
import PaginationControl from "@/components/UI/pagination";

export default {
  data() {
    return {
      currentTab: "private",
      totalTransaction: null,
      loading: true,
      sortOptions: {
        pageSize: 10,
        pageNumber: 1,
        startDate: null,
        endDate: null,
        searchString: "",
      },
      allCollection: [],
      allCollectionProperty: {},
    };
  },
  components: {
    TableFilter,
    TableCollections,
    PageHeader,
    PaginationControl,
  },
  computed: {
    payload() {
      return {
        pageSize: this.sortOptions.pageSize,
        pageNumber: this.sortOptions.pageNumber,
        type: this.currentTab,
        searchTerm: this.sortOptions.searchString,
        startDate:
          this.sortOptions.startDate != null
            ? moment(this.sortOptions.startDate).format("YYYY-MM-DD")
            : "",
        endDate:
          this.sortOptions.endDate != null
            ? moment(this.sortOptions.endDate).format("YYYY-MM-DD")
            : "",
      };
    },
  },
  mounted() {
    this.getAllCollection();
  },

  watch: {
    sortOptions() {
      this.getAllCollection();
    },
    currentTab() {
      this.getAllCollection();
    },
  },
  methods: {
    setNumDisplayCollection(val) {
      this.sortOptions = { ...this.sortOptions, pageSize: val };
    },
    setPageDisplayCollection(val) {
      this.sortOptions = { ...this.sortOptions, pageNumber: val };
    },
    sortItemProps(val) {
      this.sortOptions = { ...this.sortOptions, ...val };
    },
    async getAllCollection() {
      this.loading = true;
      try {
        let response = await this.$_getAllTransaction(this.payload);

        this.allCollection = response.data.transactions;
        this.totalCollection = response.data.totalCount;
        this.allCollectionProperty = response.data;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  @apply bg-gray-300;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
.unit-point {
  @apply flex shadow-xl px-4 py-4 rounded-lg items-center;
  width: 47%;
}
</style>
